import { graphql, useStaticQuery } from 'gatsby';
import React, { Dispatch, FC, SetStateAction } from 'react';

import { keysToCamel } from '@utils/butter';

import { AuthStepContext } from '@providers/AuthProvider';

import PhoneNumberEnrollmentForm, {
	IPhoneNumberEnrollmentFormContent,
} from './PhoneNumberEnrollmentForm.component';

interface IPhoneNumberEnrollmentFormPageProps {
	authStep: AuthStepContext;
	setAuthStep: (authContext: AuthStepContext) => void;
	setPhoneNumber: Dispatch<SetStateAction<string>>;
	isSignUp?: boolean;
	setNotify?: Dispatch<SetStateAction<boolean | 'true' | null | undefined>>;
}

const PhoneNumberEnrollmentFormPage: FC<IPhoneNumberEnrollmentFormPageProps> = ({
	authStep,
	setAuthStep,
	setPhoneNumber,
	setNotify,
	isSignUp = false,
}) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "sms-mfa-phone-enrollment" }) {
				sign_in {
					title
					description
				}
				sign_up {
					title
					description
				}
				disclaimer
				checkbox_label
			}
		}
	`);

	const refinedContent: IPhoneNumberEnrollmentFormContent = keysToCamel({
		...pageContent,
		...(isSignUp ? pageContent.sign_up : pageContent.sign_in),
	}) as IPhoneNumberEnrollmentFormContent;

	return (
		<PhoneNumberEnrollmentForm
			authStep={authStep}
			setAuthStep={setAuthStep}
			pageContent={refinedContent}
			setPhoneNumber={setPhoneNumber}
			setNotify={setNotify}
			isSignUp={isSignUp}
		/>
	);
};

export default PhoneNumberEnrollmentFormPage;
